import React from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import Layout from '../components/layout'
import aj from '../images/AJ.jpg'
import andrew from '../images/AndrewAskins.jpg'
import jisola from '../images/MsJisola.jpg'

class JobBoardGuidelinesPage extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const color = 'rgb(211, 232, 225)'
    const category = 'Work With Us'
    const description = ''

    return (
      <Layout location={this.props.location} style={{ backgroundColor: color }}>
        <Helmet
          htmlAttributes={{ lang: 'en' }}
          meta={[
            { name: 'description', content: description },
            { property: 'og:title', content: category },
            {
              property: 'og:description',
              content: description,
            },
            {
              property: 'twitter:title',
              content: category,
            },
            {
              property: 'twitter:description',
              content: description,
            },
          ]}
          title={siteTitle}
        />
        <div className="max-w-screen-xl pt-6 mx-auto md:p-12">
          {/* //headline */}
          <div className="p-4 text-center">
            <h2 className="mt-6 mb-4 text-3xl font-extrabold leading-10 tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:text-5xl">
              Work with Us
              <br />
              <span className="mt-3 font-bold leading-5 text-indigo-600">
                Connect with underestimated folks in tech
              </span>
            </h2>
          </div>

          <div className="p-6 pb-2 m-2 text-xl leading-normal bg-white border rounded border-light-grey">
            <p>
              Diversify Tech is a newsletter that connects underrepresented
              people in tech to jobs, events, scholarships and speaking
              opportunities.
            </p>

            <div>
              <h2 className="text-2xl font-extrabold leading-9 text-gray-900 sm:text-3xl sm:leading-10">
                Our Community
              </h2>
              <p className="mt-3 text-xl leading-7 sm:mt-4">
                Our community consists of developers, designers, data and
                product folks primarily in the United States. It is a mix of
                entry-level to senior level people.{' '}
              </p>
            </div>

            <h2 className="text-center">💌 Newsletter Stats</h2>
            <h3 className="text-center">Professional edition</h3>
            <div className="pb-12 mt-10 bg-white sm:pb-16">
              <div className="relative">
                <div className="absolute inset-0 h-1/2" />
                <div className="relative max-w-screen-xl px-4 mx-auto sm:px-6 lg:px-8">
                  <div className="max-w-4xl mx-auto">
                    <dl className="bg-white rounded-lg shadow-lg sm:grid sm:grid-cols-3">
                      <div className="flex flex-col p-6 text-center border-b border-gray-100 sm:border-0 sm:border-r">
                        <dt
                          className="order-2 mt-2 text-lg font-medium leading-6 text-gray-600"
                          id="item-1"
                        >
                          subscribers
                        </dt>
                        <dd
                          className="order-1 text-4xl font-extrabold leading-none text-red-500"
                          aria-describedby="item-1"
                        >
                          13,150
                        </dd>
                      </div>
                      <div className="flex flex-col p-6 text-center border-t border-b border-gray-100 sm:border-0 sm:border-l sm:border-r">
                        <dt className="order-2 mt-2 text-lg font-medium leading-6 text-gray-600">
                          open rate
                        </dt>
                        <dd className="order-1 text-4xl font-extrabold leading-none text-red-500">
                          46%
                        </dd>
                      </div>
                      <div className="flex flex-col p-6 text-center border-t border-gray-100 sm:border-0 sm:border-l">
                        <dt className="order-2 mt-2 text-lg font-medium leading-6 text-gray-600">
                          click rate
                        </dt>
                        <dd className="order-1 text-4xl font-extrabold leading-none text-red-500">
                          9%
                        </dd>
                      </div>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
            <h2 className="text-center">💌 Newsletter Stats</h2>
            <h3 className="text-center">Student edition</h3>
            <div className="pb-12 mt-10 bg-white sm:pb-16">
              <div className="relative">
                <div className="absolute inset-0 h-1/2" />
                <div className="relative max-w-screen-xl px-4 mx-auto sm:px-6 lg:px-8">
                  <div className="max-w-4xl mx-auto">
                    <dl className="bg-white rounded-lg shadow-lg sm:grid sm:grid-cols-3">
                      <div className="flex flex-col p-6 text-center border-b border-gray-100 sm:border-0 sm:border-r">
                        <dt
                          className="order-2 mt-2 text-lg font-medium leading-6 text-gray-600"
                          id="item-1"
                        >
                          subscribers
                        </dt>
                        <dd
                          className="order-1 text-4xl font-extrabold leading-none text-blue-500"
                          aria-describedby="item-1"
                        >
                          3,900
                        </dd>
                      </div>
                      <div className="flex flex-col p-6 text-center border-t border-b border-gray-100 sm:border-0 sm:border-l sm:border-r">
                        <dt className="order-2 mt-2 text-lg font-medium leading-6 text-gray-600">
                          open rate
                        </dt>
                        <dd className="order-1 text-4xl font-extrabold leading-none text-blue-500">
                          50%
                        </dd>
                      </div>
                      <div className="flex flex-col p-6 text-center border-t border-gray-100 sm:border-0 sm:border-l">
                        <dt className="order-2 mt-2 text-lg font-medium leading-6 text-gray-600">
                          click rate
                        </dt>
                        <dd className="order-1 text-4xl font-extrabold leading-none text-blue-500">
                          15%
                        </dd>
                      </div>
                    </dl>
                  </div>
                </div>
              </div>
            </div>

            <h2 className="text-center">📈 Website and Social Media Stats</h2>
            <div className="pb-12 mt-10 bg-white sm:pb-16">
              <div className="relative">
                <div className="absolute inset-0 h-1/2" />
                <div className="relative max-w-screen-xl px-4 mx-auto sm:px-6 lg:px-8">
                  <div className="max-w-4xl mx-auto">
                    <dl className="bg-white rounded-lg shadow-lg sm:grid sm:grid-cols-2">
                      <div className="flex flex-col p-6 text-center border-b border-gray-100 sm:border-0 sm:border-r">
                        <dt
                          className="order-2 mt-2 text-lg font-medium leading-6 text-gray-600"
                          id="item-1"
                        >
                          website traffic in the last 30 days
                        </dt>
                        <dd
                          className="order-1 text-4xl font-extrabold leading-none text-teal-500"
                          aria-describedby="item-1"
                        >
                          11,632
                        </dd>
                      </div>
                      <div className="flex flex-col p-6 text-center border-t border-b border-gray-100 sm:border-0 sm:border-l sm:border-r">
                        <dt className="order-2 mt-2 text-lg font-medium leading-6 text-gray-600">
                          Twitter followers
                        </dt>
                        <dd className="order-1 text-4xl font-extrabold leading-none text-indigo-500">
                          23 K
                        </dd>
                      </div>
                    </dl>
                  </div>
                </div>
              </div>
            </div>

            {/* <div>
              <h2 className="text-2xl font-extrabold leading-9 text-gray-900 sm:text-3xl sm:leading-10">
                Our Newsletters
              </h2>
              <p className="mt-3 text-xl leading-7 sm:mt-4">
                Our newsletter goes out every Tuesday night at 9pm. It includes
                jobs from our job board, tech events, scholarships and speaking
                opportunities.
              </p>
            </div> */}

            <p>Here are a few ways to work with us!</p>
            <h2
              id="hire"
              className="text-2xl font-extrabold leading-9 text-gray-900 sm:text-3xl sm:leading-10"
            >
              1. Hire
            </h2>
            <h3 className="mt-6 mb-4">Job Board</h3>
            <p>
              Share your job opportunities through our{' '}
              <a href="/job-board/">job board</a> and{' '}
              <a href="https://mailchi.mp/diversifytech/103">newsletter</a>.
            </p>
            <p>
              Each job posting is shown on the job board for 30 days or till the
              application deadline, emailed directly to our subscribers and
              promoted on Twitter. The price is $199 for one posting or $149 per
              posting for multiple job postings. It is $99 per posting for
              non-profits.
            </p>
            <p>
              We ask for transparency in your demographics, salary, interview
              process and Diversity and Inclusion efforts.
            </p>
            <p>
              We'd love to have your Engineering, Product, Design or Data roles
              on our job board. Please post them <a href="/post-a-job">here</a>!
            </p>

            <h3 className="mt-6 mb-4">Talent Directory (free)</h3>
            <p>
              You can find some of our members who are looking for new roles in
              our talent directory.
            </p>
            <p>
              This is a free resource at this time. Please{' '}
              <a href="/hire">reach out to folks directly</a>.
            </p>

            <h2
              id="advertise"
              className="mt-6 text-2xl font-extrabold leading-9 text-gray-900 sm:text-3xl sm:leading-10"
            >
              2. Share your resource
            </h2>

            <p>
              Share your events, scholarships, communities, and CFPs with our
              community. We'll list it on our website and newsletter (if
              relevant to our community).
            </p>

            <p>
              It is <i>free</i> to list on our website.{' '}
              <a href="https://airtable.com/shrWvRLZTWFfOKCRo">
                Share your resource with us
              </a>
              .{' '}
            </p>
            <h2
              id="sponsor"
              className="mt-6 text-2xl font-extrabold leading-9 text-gray-900 sm:text-3xl sm:leading-10"
            >
              3. Sponsor
            </h2>

            <p>
              We can feature you through a sponsorship. We offer three options.
            </p>
            <p className="leading-none">
              <i>
                <small>
                  Please note that we don't share job postings through
                  sponsorships. We have a different process for job openings as
                  we require information like salary, demographics of the
                  company, etc. Please{' '}
                  <a href="https://www.diversifytech.co/post-a-job">
                    post on our job board
                  </a>{' '}
                  instead.
                </small>
              </i>
            </p>

            <div>
              <div class="max-w-xl mx-auto lg:max-w-screen-xl">
                <div>
                  <div class="mt-10 lg:mt-0">
                    <div>
                      <h3 class="leading-6 text-indigo-600">Silver ($500)</h3>
                      <div class="mt-2  leading-6">
                        <ul>
                          <li>
                            We'll feature in the top section of the newsletter.
                          </li>
                          <li>
                            We'll feature you in <b>one</b> weekly digest. You
                            will get a dedicated section.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="mt-10 lg:mt-0">
                    <div>
                      <h3 class="leading-6 text-yellow-700">Gold ($1000)</h3>
                      <div class="mt-2  leading-6">
                        <ul>
                          <li>
                            Listed as a sponsor on the home page for a month
                          </li>
                          <li>Shout out on Twitter</li>
                          <li>
                            We'll feature you in <b>one</b> weekly digest in the
                            top section of the newsletter.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="mt-10 lg:mt-0">
                    <div>
                      <h3 class="leading-6 text-red-500">Platinum ($1500)</h3>
                      <div class="mt-2  leading-6">
                        <ul>
                          <li>
                            Listed as a sponsor on the home page for a month
                          </li>
                          <li>Shout out on Twitter</li>
                          <li>
                            We'll feature you in <b>3</b> weekly digests
                          </li>
                          <li>
                            We'll feature in the top section of the newsletter
                            for each one.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <p>Here are a few examples:</p>
                <ul>
                  <li>
                    We have had conferences like{' '}
                    <a href="https://mailchi.mp/diversifytech/100">
                      Write the Docs
                    </a>
                    ,{' '}
                    <a href="https://mailchi.mp/diversifytech/79">CascadiaJS</a>
                    ,and{' '}
                    <a href="https://mailchi.mp/diversifytech/98">
                      {' '}
                      Webflow Virtual World Tour
                    </a>{' '}
                    share their Call For Proposals with us.
                  </li>
                  <li>
                    <a href="">Shine Bootcamp</a>, a speaker accelerator,
                    advertised their scholarship with us.
                  </li>
                  <li>
                    <a href="https://mailchi.mp/diversifytech/90">Badassery</a>,
                    a curated community of rising leaders, advertised their
                    community.
                  </li>
                </ul>

                <p>
                  Interested in sponsoring us? Please inquire{' '}
                  <a href="https://form.jotform.com/212662749604157">here</a>.
                </p>
              </div>
            </div>

            <h2 className="mt-6 mb-4 text-2xl font-extrabold leading-9 text-gray-900 sm:text-3xl sm:leading-10">
              Here is what our community has to say
            </h2>

            {/* <ul class="md:grid md:grid-cols-3 md:col-gap-4 md:row-gap-4 list-none p-0"> */}
            <div className="max-w-lg mx-auto lg:max-w-screen-lg">
              <div className="lg:grid lg:grid-cols-3 ">
                <div class="mt-10 md:mt-0 border rounded border-light-grey p-4 m-4">
                  <div class="flex">
                    <div class="flex-shrink-0">
                      <img src={jisola} className="w-12 h-12 rounded-full" />
                    </div>
                    <div class="ml-4 text-sm">
                      <p>I wish I could retweet this a billion times!</p>
                      <p>
                        Your newsletter has definitely changed the trajectory of
                        my life! All the connections I’ve made and people I’ve
                        met!
                      </p>
                      <p>Thank you!!! 👏🏾👏🏾👏🏾</p>
                      &mdash; AO WFH &amp; coding 💻 (@MsJisola){' '}
                      <a href="https://twitter.com/MsJisola/status/1277393775057403904?ref_src=twsrc%5Etfw">
                        June 29, 2020
                      </a>
                    </div>
                  </div>
                </div>

                <div class="mt-10 md:mt-0 border rounded border-light-grey p-4 m-4">
                  <div class="flex">
                    <div class="flex-shrink-0">
                      <img src={andrew} className="w-12 h-12 rounded-full" />
                    </div>
                    <div class="ml-4 text-sm">
                      <p>
                        Diversify Tech's job board is 🔥
                        <br />
                        <br />
                        It's one of the first places we post every new opening
                      </p>
                      &mdash; Andrew (@AndrewAskins){' '}
                      <a href="https://twitter.com/AndrewAskins/status/1283477634102550529?ref_src=twsrc%5Etfw">
                        July 15, 2020
                      </a>
                    </div>
                  </div>
                </div>
                <div class="mt-10 md:mt-0 border rounded border-light-grey p-4 m-4">
                  <div class="flex">
                    <div class="flex-shrink-0">
                      <img src={aj} className="w-12 h-12 rounded-full" />
                    </div>
                    <div class="ml-4 text-sm">
                      <p lang="en" dir="ltr">
                        🗣️ Shout out to{' '}
                        <a href="https://twitter.com/venikunche?ref_src=twsrc%5Etfw">
                          @venikunche
                        </a>{' '}
                        for her impactful work connecting underrepresented folks
                        in tech with career resources!
                        <br />
                        <br />
                        I&#39;m wrapping up week 1 at a 🔥 job I found listed
                        within the amazing collection of job opportunities{' '}
                        <a href="https://twitter.com/DiversifyTechCo?ref_src=twsrc%5Etfw">
                          @DiversifyTechCo
                        </a>
                        . 😎
                      </p>
                      &mdash; AJ Johnson 🏳️‍🌈 (@AJilityJ){' '}
                      <a href="https://twitter.com/AJilityJ/status/1286511268757528576?ref_src=twsrc%5Etfw">
                        July 24, 2020
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <h2 className="text-2xl leading-9 font-extrabold text-gray-900 sm:text-3xl sm:leading-10 mb-4 mt-6Î">
              Questions?
            </h2>
            <p>
              If you have any additional questions, please use our{' '}
              <a href="/contact">contact form</a>. We'll be more than happy to
              hear from you.
            </p> */}
          </div>
        </div>
      </Layout>
    )
  }
}

export default JobBoardGuidelinesPage
